export const LABEL_APPNAME = 'podeux';
export const LABEL_TAGLINE = "Chat to find your next show.";
export const LABEL_DOMAIN = 'podeux.com';
export const IOS_APP_STORE_LINK = 'https://apps.apple.com/us/app/podeux/id6477985096';

export const PREFERENCE_COPY_TITLE = 'Customize your feed';
export const PREVIEW_PREFERENCE_COPY_TITLE = 'More or less';
export const PREVIEW_PREFERENCE_COPY_SUBTITLE = 'Choose what you want to hear more or less of.';

export const SAVED_LISTS_CONTAINER_ID = 'savedListsContainer';

export const MAX_PREVIEWS_LOGGED_OUT = 8;
